<template>
    <div class="image-toggle-field"><span v-on:click="toggleValue()" class="glyphicon" v-bind:class="glyphiconClass"></span></div>
</template>

<script>
    import baseField from 'vue-formly-bootstrap/src/fields/baseField'

    export default {
        mixins: [baseField],
        props: ['form', 'field', 'model'],
        name: 'imageToggle',
        data () {
            return {}
        },
        computed: {
            glyphiconClass: function () {
                let trueGlyphicon = this.field.templateOptions.trueGlyphicon || 'glyphicon-star'
                let falseGlyphicon = this.field.templateOptions.falseGlyphicon || 'glyphicon-star-empty'
                return this.model[this.field.key] ? trueGlyphicon : falseGlyphicon
            }
        },
        methods: {
            toggleValue: function () {
                try {
                    this.model[this.field.key] = !this.model[this.field.key] ? 1 : 0
                } catch (e) {
                    if (e instanceof TypeError) {
                    } else {
                        throw e
                    }
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// ImageToggle.vue?2e216c02